import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getEmailNotificationsQuery, updateEmailNotificationsQuery } from '../services/emailNotificationsService';
import { queryKeys } from './queryKeys';

// The signed-in person's email settings. Always fetched fresh when the page opens: opening the link in a confirmation email changes
// them somewhere else.
export const useEmailNotifications = () => useQuery({
    queryKey: queryKeys.emailNotifications(),
    queryFn: getEmailNotificationsQuery,
    staleTime: 0,
    refetchOnWindowFocus: true,
});

export const useUpdateEmailNotifications = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateEmailNotificationsQuery,
        onSuccess: (emailNotifications) => { queryClient.setQueryData(queryKeys.emailNotifications(), emailNotifications); },
    });
};
